import { journeySteps, type JourneyStep } from "../../domain/product";

export function JourneyRail({ current, onSelect }: { current: JourneyStep; onSelect: (step: JourneyStep) => void }) {
  const activeIndex = journeySteps.findIndex((item) => item.id === current);
  return (
    <section className="journeyRail" aria-label="SHADOW journey">
      {journeySteps.map((item, index) => (
        <button
          key={item.id}
          type="button"
          className={item.id === current ? "active" : index < activeIndex ? "complete" : undefined}
          onClick={() => onSelect(item.id)}
          aria-current={item.id === current ? "step" : undefined}
        >
          <span>{item.label}</span>
          <strong>{item.title}</strong>
        </button>
      ))}
    </section>
  );
}
